var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.581 11L20.141 8.21L20.481 4.52L16.871 3.7L14.981 0.5L11.581 1.96L8.18099 0.5L6.29099 3.69L2.68099 4.5L3.02099 8.2L0.580994 11L3.02099 13.79L2.68099 17.49L6.29099 18.31L8.18099 21.5L11.581 20.03L14.981 21.49L16.871 18.3L20.481 17.48L20.141 13.79L22.581 11ZM8.96099 15.01L6.58099 12.61C6.19099 12.22 6.19099 11.59 6.58099 11.2L6.65099 11.13C7.04099 10.74 7.68099 10.74 8.07099 11.13L9.68099 12.75L14.831 7.59C15.221 7.2 15.861 7.2 16.251 7.59L16.321 7.66C16.711 8.05 16.711 8.68 16.321 9.07L10.401 15.01C9.99099 15.4 9.36099 15.4 8.96099 15.01Z",
    fill: "#19C48F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCheckbox);
export default __webpack_public_path__ + "static/media/star_checkbox.46b333306154ca42b7626ab3317af2a7.svg";
export { ForwardRef as ReactComponent };